import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { Fields } from "@repoflow/components/fields";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>View</BreadcrumbItem>
  </>
);

export const Content = () => {
  const {
    values,
    schema, 
    base
  } = useSectionContext();


  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">
            {/* The edit route exists and is the only way to change a member's
                status or roles after they are invited; nothing linked to it. */}
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            target={{ $ref: "/Public/OrganizationUsers" }}
            config={{
              "/Public/OrganizationUsers": {
                fields: ["email", "status", "roles", "createdAt"],
              },
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
